import { Clock, FileIcon, Loader2 } from "lucide-react";
import { formatBytes, formatMinutes } from "@/lib/utils";
import { MediaDurationStatus } from "@/lib/mediaDuration";

interface SelectedFileCardProps {
  file: File;
  durationStatus?: MediaDurationStatus;
  durationMinutes?: number | null;
  availableMinutes?: number | null;
  remainingMinutes?: number | null;
  onRetry?: () => void;
}

const SelectedFileCard = ({
  file,
  durationStatus = "idle",
  durationMinutes = null,
  availableMinutes = null,
  remainingMinutes = null,
  onRetry,
}: SelectedFileCardProps) => {
  const roundedDurationMinutes =
    durationMinutes !== null ? Math.max(Math.ceil(durationMinutes), 0) : null;

  return (
    <div className="flex items-start space-x-3 px-3 py-2 bg-muted border border-border rounded-md">
      <div className="flex flex-col items-center flex-shrink-0">
        <div className="h-6 w-6 text-muted-foreground flex items-center justify-center">
          <FileIcon size={16} />
        </div>
        <p className="text-xs text-muted-foreground mt-1 text-center">{formatBytes(file.size)}</p>
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm text-foreground font-mono break-words">{file.name}</p>
        <div className="mt-2 space-y-1 text-xs text-muted-foreground">
          {durationStatus === "checking" && (
            <div className="flex items-center gap-1 text-brand-600">
              <Loader2 className="h-3 w-3 animate-spin" />
              <span>Анализируем длительность...</span>
            </div>
          )}

          {durationStatus === "ready" && roundedDurationMinutes !== null && (
            <div className="flex items-center gap-1 text-foreground">
              <Clock className="h-3 w-3" />
              <span>Длительность: ~{formatMinutes(roundedDurationMinutes)}</span>
            </div>
          )}

          {remainingMinutes !== null && durationStatus === "ready" && remainingMinutes >= 0 && (
            <div className="flex items-center gap-1">
              <span>Остаток после обработки:</span>
              <span
                className={
                  remainingMinutes >= 0
                    ? "text-emerald-600 font-semibold"
                    : "text-destructive font-semibold"
                }
              >
                {formatMinutes(Math.max(Math.round(remainingMinutes), 0))}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectedFileCard;
